"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)((0, vue_1.resolveDynamicComponent)(_ctx.componentName), {
        ref: "childInput",
        players: _ctx.players,
        playerView: _ctx.playerView,
        playerinput: _ctx.playerinput,
        onsave: _ctx.onsave,
        showsave: _ctx.showsave,
        showtitle: _ctx.showtitle
    }, null, 8, ["players", "playerView", "playerinput", "onsave", "showsave", "showtitle"]));
}
